export const Header = props => {
    return <h1 className="text-4xl font-bold text-gray-800 my-12 mx-4" >{props.text}</h1>
}